import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, FilePlus, X } from 'lucide-react';
import './CreateProjectModal.css'; 

const CreateProjectModal = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleAIProjectClick = () => {
        navigate('/ai-project-onboarding/select-template');
        onClose();
    };

    const handleBlankProjectClick = () => {
        navigate('/job-detail-new');
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close-btn" onClick={onClose}>
                    <X size={24} />
                </button>
                <div className="modal-header-center">
                    <h2>Create a New Project</h2>
                    <p>How would you like to start?</p>
                </div>

                <div className="project-options">
                    <div className="option-card" onClick={handleAIProjectClick}>
                        <div className="option-icon">
                            <Sparkles size={32} color="#007bff" />
                        </div>
                        <h3>AI-Assisted Project</h3>
                        <p><strong>Recommended</strong></p>
                        <p>Let our AI build a project plan for you. We'll suggest phases, jobs, and the contractors you'll need.</p>
                        <button className="primary-btn">Start AI Project</button>
                    </div>

                    <div className="option-card" onClick={handleBlankProjectClick}>
                        <div className="option-icon">
                            <FilePlus size={32} color="#6c757d" />
                        </div>
                        <h3>Blank Project</h3>
                        <p>Start with an empty project and add jobs manually.</p>
                        <p>Best for custom or unique projects where you know exactly what you need.</p>
                        <button className="secondary-btn">Start Blank Project</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateProjectModal;
